import { render, staticRenderFns } from "./MyMove.vue?vue&type=template&id=216e822e&scoped=true"
import script from "./MyMove.vue?vue&type=script&lang=js"
export * from "./MyMove.vue?vue&type=script&lang=js"
import style0 from "./MyMove.vue?vue&type=style&index=0&id=216e822e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216e822e",
  null
  
)

export default component.exports